import { Component } from '@angular/core';

@Component({
  selector: 'fz-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent {
  onActivate() {
    window.scroll(0, 0);
  }
}
